/* unplugin-vue-components disabled */import script from "./selectUser.vue?vue&type=script&setup=true&name=SelectUser&lang=js"
export * from "./selectUser.vue?vue&type=script&setup=true&name=SelectUser&lang=js"

const __exports__ = script;

export default __exports__